import { COURSE_SECTIONS } from '../actions/course';

export const courseSectionsReducer = (state = '', action) => {
  switch (action.type) {
    case COURSE_SECTIONS:
      return action.payload;
  }
  return state;
};
